<section id="dynamic-category-header-2345674" class="dynamic-header-background editable">
    <div class="header-layout-13" style="position: relative">
        <div class="top-section non-editable">
            <div class="logo-hamburger-wrapper">
                @if (headerData && headerData.menuListVisibleOnMobile) {
                <img (click)="toggleMobileHamburgerMenu()" class="hamburger-btn header-hamburger-icon mobile-only width-20" [src]="headerData.mobileHamburgerMenuIcon" />
                }

                <!-- mobile logo icon -->
                @if (headerData.logo.isVisibleOnMobile && selectedDeviceType === device.mobile) {
                <a class="logo" [routerLink]="['/']"><img class="header-logo-icon" [src]="headerData.logo.logoSrc" /> </a>
                } @else {
                <div class="logo-section-width">
                    <!-- desktop logo icon -->
                    <div class="logo-hamburger-wrapper">
                        @if (headerData.logo.isVisibleOnDesktop && selectedDeviceType === device.desktop) {
                        <a class="logo" [routerLink]="['/']"><img class="header-logo-icon" [src]="headerData.logo.logoSrc" />
                        </a>
                        }
                    </div>
                </div>
                }
            </div>
            <div class="search-operations-container">
                @if (!isSearchOverlay && headerData.searchIcon.isVisibleOnDesktop) {
                <base-search-bar class="only-desktop" [searchSuggestionConfiguration]="headerData && headerData.searchSuggestionConfiguration" [selectedDeviceType]="selectedDeviceType" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="isSearchOverlay"></base-search-bar>
                }
            </div>
            <div class="operation-button-container">
                @if (headerData.searchIcon.isVisibleOnDesktop && selectedDeviceType === device.desktop) {
                <a class="button search-btn dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" (click)="toggleSearchDropDown()">
                    <img class="header-search-icon" [src]="headerData.searchIcon.searchIconSrc" />
                </a>
                } @else {
                @if (headerData.searchIconMobile.isVisibleOnMobile && selectedDeviceType === device.mobile) {
                <a class="button search-btn dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" (click)="toggleSearchDropDown()">
                    <img class="header-search-icon" [src]="headerData.searchIconMobile.searchIconMobileSrc" />
                </a>
                }
                }

                <!-- mobile account icon -->
                @if (headerData.accountIcon.isVisibleOnMobile && selectedDeviceType === device.mobile) {
                <a class="button header-account-indicator dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" (click)="isMobileHamburgerMenu = false" [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']">
                    <img class="header-account-icon header-account-indicator" [src]="headerData.accountIcon.accountIconSrc" />
                </a>
                } @else {
                <!-- desktop account icon -->
                @if (headerData.accountIcon.isVisibleOnDesktop && selectedDeviceType === device.desktop) {
                <a class="button header-account-indicator dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']">
                    <img class="header-account-icon header-account-indicator" [src]="headerData.accountIcon.accountIconSrc" />
                </a>
                }
                }

                <!-- mobile cart icon -->
                @if (headerData.cartIcon.isVisibleOnMobile && selectedDeviceType === device.mobile) {
                <a class="button cart-btn header-cart-indicator dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" (click)="isMobileHamburgerMenu = false" [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                    <img class="header-cart-icon header-cart-indicator" [src]="headerData.cartIcon.cartIconSrc" />

                    <span class="cart-count dynamic-cart-count-text-color header-cart-indicator dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">{{ cart.cart_items.length }}</span>
                </a>
                } @else {
                <!-- desktop cart icon -->
                @if (headerData.cartIcon.isVisibleOnDesktop && selectedDeviceType === device.desktop) {
                <a class="button cart-btn header-cart-indicator dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                    <img class="header-cart-icon header-cart-indicator" [src]="headerData.cartIcon.cartIconSrc" />

                    <span class="cart-count header-cart-indicator dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">{{ cart.cart_items.length }}</span>
                </a>
                }
                }
            </div>
        </div>
        <div class="bottom-section dynamic-header-background desktop-only-g">
            <!-- NEW: Desktop hamburger menu section -->
            <div class="bottom-left-section">
                <div class="logo-hamburger-wrapper dynamic-desktop-hamburger-background hamburger-wrapper-relative dynamic-desktop-hamburger-border" [ngClass]="{
            'hamburger-desktop-only': headerData.menuListVisibleOnDesktop && selectedDeviceType === device.desktop,
            'hamburger-menu-open': isDesktopHamburgerMenu,
          }">
                    <div class="hamburger-desktop-onlys hamburger-button-container" (click)="toggleDesktopHamburgerMenu(); $event.stopPropagation()">
                        @if (headerData.menuListVisibleOnDesktop) {
                        <img class="hamburger-btn header-hamburger-icon width-20" [src]="headerData.desktopHamburgerMenuIcon" />
                        }
                        <span class="header-menu-title dynamic-desktop-hamburger-text-color desktop-hamburger-menu-name">{{
              headerData.desktopHamburgerMenuName || 'All Departments'
            }}</span>
                    </div>
                    <!-- NEW: Desktop side menu -->
                    @if (isDesktopHamburgerMenu && headerData.menuListVisibleOnDesktop) {
                    <div appClickOutside (clickOutside)="toggleDesktopHamburgerMenu()" class="hamburger-menu-container hamburger-menu-desktop-container hamburger-menu-position" [ngClass]="{
                'hamburger-menu-open': headerData.menuListVisibleOnDesktop,
              }">
                        <div class="mobile-category-panel hamburger-menu-panel desktop-hamburgur-menu-panel dynamic-desktop-hamburger-panel-text-color dynamic-desktop-hamburger-panel-background" (click)="$event.stopPropagation()">
                            @if (category && category.length > 0) {
                            <webstore-dynamic-menu-collapse #dynamicCategoryHeaderMobile [categories]="category" [menuCollapseIcon]="headerData.menuCollapseIcon" (hideMenu$)="toggleDesktopHamburgerMenu()"></webstore-dynamic-menu-collapse>
                            } @else {
                            <div class="desktop-hamburger-empty-state">
                                <img [src]="IMAGE_URLS.header11CategoryEmptyStateImage" alt="Empty state" />
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>
            <!-- Keep existing navigation menu -->
            <div class="bottom-center-section">
                @if (headerData.menuListVisibleOnDesktop) {
                <nav #changeHeaderElement class="navigation-wrapper non-editable mega-menu-category">
                    <ul class="navigation-list static-nav non-editable dynamic-menu-alignment">
                        @for (staticMenu of headerData.menuItems; track staticMenu.id) {
                        @if (staticMenu.text !== 'Category Header') {
                        <li class="editable static-menu">
                            <a [ngClass]="{
                        'hover-color-active': showActiveColor && currentMenuId === staticMenu.id,
                        'hover-color-inactive': !showActiveColor && currentMenuId === staticMenu.id,
                      }" [id]="staticMenu.id" class="static-header dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu" [target]="staticMenu.target" [attr.data-click_action_value]="staticMenu['data-click_action_value']" [attr.data-click_action_choice]="staticMenu['data-click_action_choice']">{{ staticMenu.text }}</a>
                        </li>
                        }
                        }
                    </ul>
                </nav>
                }
            </div>
            @if (
            headerData.contactIcon && headerData.contactIcon.isVisibleOnDesktop && selectedDeviceType === device.desktop
            ) {
            <a [href]="'tel:' + headerData.contactIcon.contactNo" class="contact-btn only-desktop header-contact-indicator">
                <img class="header-contact-icon" [src]="headerData.contactIcon.contactIconSrc" />

                <div class="contact-info">
                    <span class="number-message-text header-editable-text dynamic-icon-content-text-color dynamic-header-text-color">{{ headerData.contactIcon.contactNoTextContent }}</span>
                    <span class="mobile-number header-editable-text dynamic-icon-content-text-color dynamic-header-text-color">{{ headerData.contactIcon.contactNo }}</span>
                </div>
            </a>
            }
        </div>

        @if (isSearchOverlay && headerData.searchIcon.isVisibleOnDesktop) {
        <div class="search-drop-down-container" (click)="toggleSearchDropDown(); $event.stopPropagation()">
            <div class="search-drop-down dynamic-header-background" (click)="$event.stopPropagation()">
                <h5 class="dynamic-header-text-color">Start your amazing search :</h5>
                <button class="close-btn" (click)="toggleSearchDropDown(); $event.stopPropagation()">
                    <img [src]="IMAGE_URLS.closeLineIcon" />
                </button>

                <base-search-bar [searchSuggestionConfiguration]="headerData && headerData.searchSuggestionConfiguration" [selectedDeviceType]="selectedDeviceType" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="isSearchOverlay"></base-search-bar>
            </div>
        </div>
        }

        <!-- NEW: Mobile hamburger menu with updated positioning -->
        @if (isMobileHamburgerMenu && headerData.menuListVisibleOnMobile && selectedDeviceType === device.mobile) {
        <div class="hamburger-menu-container" appClickOutside #changeHeaderMobileElement (click)="toggleMobileHamburgerMenu(); $event.stopPropagation()" [ngClass]="{
          'hamburger-menu-open-mobile': headerData.menuListVisibleOnMobile,
        }">
            <div class="hamburger-menu mobile-category-panel" (click)="$event.stopPropagation()">
                <static-menu-collapse [headerData]="headerData" (hideMenu$)="toggleMobileHamburgerMenu()">
                </static-menu-collapse>
                @if (category) {
                <webstore-dynamic-menu-collapse #dynamicCategoryHeaderMobile [categories]="category" [menuCollapseIcon]="headerData.menuCollapseIcon" (hideMenu$)="toggleMobileHamburgerMenu()"></webstore-dynamic-menu-collapse>
                }
            </div>
        </div>
        }
    </div>
</section>